module.exports = __webpack_public_path__ + "img/pointB_gr1_5.004e66a4.png";